import { useEffect, useState } from 'react';

export default function usePardotUrl(url?: string) {
  const [pardotURL, set] = useState(url);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    set(initial => (initial ? `${initial}${window.location.search}` : ''));
  }, []);

  return pardotURL;
}
